import { BYO_MARKET_FETCHING_STARTED, BYO_MARKETS_SUCCESS, BYO_ERRORS_CLEAN_ALL, BYO_ERRORS_SHOW_EVENT_LEVEL, BYO_ERRORS_HIDE_EVENT_LEVEL, BYO_ADD_FAVOURITE, BYO_REMOVE_FAVOURITE, BYO_MARKET_CATEGORIES_FILTER, } from '../constants';
import { favouriteCategoriesService } from '../../services';
import { DEFAULT_MARKET_CATEGORY } from '../../constants';
const initialState = {
    data: null,
    hasMarketsError: false,
    isFetching: false,
    categoryNameFilter: DEFAULT_MARKET_CATEGORY,
};
// eslint-disable-next-line complexity
const marketsReducer = (state = initialState, action = {}) => {
    if (action.type === BYO_MARKET_FETCHING_STARTED) {
        return Object.assign(Object.assign({}, state), { isFetching: true });
    }
    if (action.type === BYO_MARKETS_SUCCESS) {
        return Object.assign(Object.assign({}, state), { data: action.payload, isFetching: false });
    }
    if (action.type === BYO_ERRORS_SHOW_EVENT_LEVEL) {
        return Object.assign(Object.assign({}, state), { hasMarketsError: true, isFetching: false });
    }
    if (action.type === BYO_ERRORS_HIDE_EVENT_LEVEL) {
        return Object.assign(Object.assign({}, state), { hasMarketsError: false });
    }
    if (action.type === BYO_ERRORS_CLEAN_ALL) {
        return Object.assign(Object.assign({}, state), { hasMarketsError: false });
    }
    if (action.type === BYO_MARKET_CATEGORIES_FILTER) {
        return Object.assign(Object.assign({}, state), { categoryNameFilter: action.categoryNameFilter });
    }
    if (state.data) {
        if (action.type === BYO_ADD_FAVOURITE) {
            const favouritesCategories = favouriteCategoriesService.addToFavouriteCategories(action.payload);
            return Object.assign(Object.assign({}, state), { data: favouriteCategoriesService.getMarketsDataWithFavourites(state.data, favouritesCategories) });
        }
        if (action.type === BYO_REMOVE_FAVOURITE) {
            const favouritesCategories = favouriteCategoriesService.removeFromFavouriteCategories(action.payload);
            return Object.assign(Object.assign({}, state), { data: favouriteCategoriesService.getMarketsDataWithFavourites(state.data, favouritesCategories) });
        }
    }
    return state;
};
export default marketsReducer;
